import { render, staticRenderFns } from "./typeGroup.vue?vue&type=template&id=fb314a88&scoped=true&"
import script from "./typeGroup.vue?vue&type=script&lang=js&"
export * from "./typeGroup.vue?vue&type=script&lang=js&"
import style0 from "./typeGroup.vue?vue&type=style&index=0&id=fb314a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb314a88",
  null
  
)

export default component.exports